const Customization = () => {
	return (
		<>
			<path
				d="M25.864 2.68964H0.473526C0.208351 2.68964 0 2.48128 0 2.21611C0 1.95094 0.208351 1.74258 0.473526 1.74258H25.864C26.1291 1.74258 26.3375 1.95094 26.3375 2.21611C26.3375 2.48128 26.1291 2.68964 25.864 2.68964Z"
				fill="#002855"
			/>
			<path
				d="M25.864 10.8911H0.473526C0.208351 10.8911 0 10.6827 0 10.4176C0 10.1524 0.208351 9.94403 0.473526 9.94403H25.864C26.1291 9.94403 26.3375 10.1524 26.3375 10.4176C26.3375 10.6827 26.1291 10.8911 25.864 10.8911Z"
				fill="#002855"
			/>
			<path
				d="M6.02326 12.2643C7.0432 12.2643 7.87001 11.4375 7.87001 10.4176C7.87001 9.39762 7.0432 8.5708 6.02326 8.5708C5.00333 8.5708 4.17651 9.39762 4.17651 10.4176C4.17651 11.4375 5.00333 12.2643 6.02326 12.2643Z"
				fill="white"
			/>
			<path
				d="M6.02328 12.7473C4.74476 12.7473 3.703 11.7055 3.703 10.427C3.703 9.14851 4.74476 8.10675 6.02328 8.10675C7.3018 8.10675 8.34355 9.14851 8.34355 10.427C8.34355 11.7055 7.3018 12.7473 6.02328 12.7473ZM6.02328 9.04433C5.26564 9.04433 4.64058 9.65991 4.64058 10.427C4.64058 11.1941 5.25617 11.8097 6.02328 11.8097C6.79039 11.8097 7.40597 11.1941 7.40597 10.427C7.40597 9.65991 6.79039 9.04433 6.02328 9.04433Z"
				fill="#002855"
			/>
			<path
				d="M25.864 20.1438H0.473526C0.208351 20.1438 0 19.9354 0 19.6703C0 19.4051 0.208351 19.1967 0.473526 19.1967H25.864C26.1291 19.1967 26.3375 19.4051 26.3375 19.6703C26.3375 19.9354 26.1291 20.1438 25.864 20.1438Z"
				fill="#002855"
			/>
			<path
				d="M11.8476 21.517C12.8675 21.517 13.6944 20.6902 13.6944 19.6703C13.6944 18.6503 12.8675 17.8235 11.8476 17.8235C10.8277 17.8235 10.0009 18.6503 10.0009 19.6703C10.0009 20.6902 10.8277 21.517 11.8476 21.517Z"
				fill="white"
			/>
			<path
				d="M11.8476 22C10.5691 22 9.52734 20.9582 9.52734 19.6797C9.52734 18.4012 10.5691 17.3595 11.8476 17.3595C13.1261 17.3595 14.1679 18.4012 14.1679 19.6797C14.1679 20.9582 13.1261 22 11.8476 22ZM11.8476 18.297C11.09 18.297 10.4649 18.9126 10.4649 19.6797C10.4649 20.4468 11.0805 21.0624 11.8476 21.0624C12.6147 21.0624 13.2303 20.4468 13.2303 19.6797C13.2303 18.9126 12.6147 18.297 11.8476 18.297Z"
				fill="#002855"
			/>
			<path
				d="M18.458 4.16701C19.4779 4.16701 20.3047 3.34019 20.3047 2.32026C20.3047 1.30033 19.4779 0.473511 18.458 0.473511C17.438 0.473511 16.6112 1.30033 16.6112 2.32026C16.6112 3.34019 17.438 4.16701 18.458 4.16701Z"
				fill="white"
			/>
			<path
				d="M18.458 4.65001C17.1795 4.65001 16.1377 3.60826 16.1377 2.32974C16.1377 1.05122 17.1795 0.00946045 18.458 0.00946045C19.7365 0.00946045 20.7782 1.05122 20.7782 2.32974C20.7782 3.60826 19.7365 4.65001 18.458 4.65001ZM18.458 0.947041C17.7003 0.947041 17.0753 1.56262 17.0753 2.32974C17.0753 3.09685 17.6909 3.71243 18.458 3.71243C19.2251 3.71243 19.8407 3.09685 19.8407 2.32974C19.8407 1.56262 19.2251 0.947041 18.458 0.947041Z"
				fill="#002855"
			/>
		</>
	);
};

export default Customization;
